import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validator, Validators} from '@angular/forms';

@Component({
    selector: 'new-credit-target-modal',
    templateUrl: './newCreditTarget.component.html',
    styleUrls: ['./newCreditTarget.component.scss'],
    standalone: false
})

export class NewCreditTargetComponent implements OnInit{
  public form: FormGroup = new FormGroup({
    title: new FormControl('', Validators.required),
    creditTarget: new FormControl(0, Validators.required),
    maxTransfer: new FormControl(null),
  });
  constructor(public dialogRef: MatDialogRef<NewCreditTargetComponent> ,
              @Inject(MAT_DIALOG_DATA) private data: any ) {
  }

  ngOnInit(){

  }
}
